import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';

const SignUpPassword = () => {
  const [form, setForm] = useState({
    name: '',
    email: '',
    password: '',
    confirmPassword: ''
  });

  const navigate = useNavigate();
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (form.password !== form.confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    try {
      const response = await axios.post(`${import.meta.env.VITE_API_BASE_URL}/api/register`, {
        name: form.name,
        email: form.email,
        password: form.password
      });

      localStorage.setItem('token', response.data.token);
      setSuccess("Registration successful! Redirecting to sign in...");

      // Optional: redirect after a delay
      setTimeout(() => {
        navigate('/signin');
      }, 2000);
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.message || "Registration failed");
    }
  };

  return (
    <div className='w-full'>
      <form onSubmit={handleSubmit} className='w-full flex flex-col gap-2 mb-[3rem]'>

        <span className='text-base font-bold text-[#abc7b9]'>Full Name</span>
        <input
          type="text"
          name="name"
          placeholder='Enter your name'
          value={form.name}
          onChange={handleChange}
          className='w-full border border-[#22BEFF33] outline-0 bg-[#143E55] text-[#abc7b9] p-3 px-4 rounded-md'
        />

        <span className='text-base font-bold text-[#abc7b9]'>Email Address</span>
        <input
          type="email"
          name="email"
          placeholder='Enter your email'
          value={form.email}
          onChange={handleChange}
          className='w-full border border-[#22BEFF33] outline-0 bg-[#143E55] text-[#abc7b9] p-3 px-4 rounded-md'
        />

        <span className='text-base font-bold text-[#abc7b9]'>Password</span>
        <input
          type="password"
          name="password"
          placeholder='Password'
          value={form.password}
          onChange={handleChange}
          className='w-full border border-[#22BEFF33] outline-0 bg-[#143E55] text-[#abc7b9] p-3 px-4 rounded-md'
        />

        <span className='text-base font-bold text-[#abc7b9]'>Confirm Password</span>
        <input
          type="password"
          name="confirmPassword"
          placeholder='Confirm Password'
          value={form.confirmPassword}
          onChange={handleChange}
          className='w-full border border-[#22BEFF33] outline-0 bg-[#143E55] text-[#abc7b9] p-3 px-4 rounded-md'
        />

        {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
        {success && <p className="text-green-500 text-sm mt-1">{success}</p>}

        <button type="submit" className='w-full bg-[#22BEFF] p-3 mt-4 rounded-md cursor-pointer text-sm font-bold'>
          Sign up
        </button>

        <p className='mt-4 text-base font-medium text-[#abc7b9] text-center'>
          Already have an account? <Link to="/signin" className='text-[#22BEFF]'>Sign in</Link>
        </p>
      </form>
    </div>
  );
};

export default SignUpPassword;
